import { createPaths } from "@routes/utils";

import type { IExtractRouteParamMap } from "@routes";

const baseRoute = `/report-management/sales-report/general`;

export const generalSalesReportRoutesObj = {
  list: baseRoute,
} as const;

export type IGeneralSalesReportRouteParams = IExtractRouteParamMap<
  typeof generalSalesReportRoutesObj
>;

export const generalSalesReportPath = createPaths<
  typeof generalSalesReportRoutesObj,
  IGeneralSalesReportRouteParams
>(generalSalesReportRoutesObj);
